module.exports = __webpack_public_path__ + "static/img/fefco712_2.a4761c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco712_2.png
// module id = P28K
// module chunks = 0